$ = jQuery;

// VIEWPORT FUNCTION
$.fn.isInViewport = function () {
//	console.log($(this));
	let elementTop = $(this).offset().top,
	elementBottom = elementTop + $(this).outerHeight(),
	viewportTop = $(window).scrollTop(),
	viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop<viewportBottom;
}

// SCROLL EVENTS
$(window).scroll(function() {
	// STICKY HEADER
	let sticky = $('header'),
		scroll = $(window).scrollTop(),
		scrollPoints = window.scrollY,
		parralaxPoints = scrollPoints / 2 - 1000;
	if (scroll >= 100) {
		sticky.addClass('sticky');
	}
	else {
		sticky.removeClass('sticky');
	}	

	// IPHONES AMINATION
	if($('.tool-phones').isInViewport()) {
		$('.iphone-img').css('top', '130%');
		$('.iphone:nth-child(2) .iphone-img').css('top', '-130%');
	}

	if($('.iphone:last-of-type').isInViewport()) {
		$('.iphone-img').css('top', '0');
	}
	
	if($('#units').isInViewport()) {
		$('.iphone-img').css('top', '-130%');
		$('.iphone:nth-child(2) .iphone-img').css('top', '130%');
	}

	// ABOUT PARALLAX
	$('#about-background').css('background-position-x', parralaxPoints+'px');

	// UNITS ANIMATIONS
	if($('.business-content').isInViewport()) {
		// business_list START
		$('.business_list .unit-background').css('transform', 'rotate(-4deg)');
		$('.business_list .unit-content .diagonal-list-item.item-1').css('left', '0%');
		$('.business_list .unit-content .diagonal-list-item.item-2').css('left', '45%');
		$('.business_list .unit-content .diagonal-list-item.item-3').css('left', '60%');
	}

	if($('.business_list .diagonal-list .item-3').isInViewport()) {
		// business_list MIDDLE
		if(window.innerWidth < 768) {
			$('.business_list .unit-content .diagonal-list-item').css('left', '0%');
		}else{
			$('.business_list .unit-content .diagonal-list-item').css('left', '30%');
		}

		$('.business_list .unit-background').css('transform', 'rotate(0deg)');
	}

	if($('#features').isInViewport()) {
		// business_list END
		$('.business_list .unit-background').css('transform', 'rotate(4deg)');
		$('.business_list .unit-content .diagonal-list-item.item-1').css('left', '60%');
		$('.business_list .unit-content .diagonal-list-item.item-2').css('left', '45%');
		$('.business_list .unit-content .diagonal-list-item.item-3').css('left', '0%');
	}

	if($('#about .under-quote').isInViewport()) {
		// B2B START
		$('.b2b .unit-background').css('transform', 'rotate(-4deg)');
		$('.b2b .unit-content .title').css('top', '4%');
		$('.b2b .unit-content .diagonal-list-item.item-1').css('left', '0%');
		$('.b2b .unit-content .diagonal-list-item.item-2').css('left', '15%');
		$('.b2b .unit-content .diagonal-list-item.item-3').css('left', '30%');
		$('.b2b .unit-content .diagonal-list-item.item-4').css('left', '45%');
		$('.b2b .unit-content .diagonal-list-item.item-5').css('left', '60%');
	}
	if($('.b2b .diagonal-list .item-3').isInViewport()) {
		// B2B MIDDLE

		if(window.innerWidth < 768) {
			$('.b2b .unit-content .title').css('top', '46%');
			$('.b2b .unit-content .diagonal-list-item').css('left', '0%');
		}else{
			$('.b2b .unit-content .diagonal-list-item').css('left', '30%');
			$('.b2b .unit-content .title').css('top', '40%');
		}

		$('.b2b .unit-background').css('transform', 'rotate(0deg)');

		// B2C START
		$('.b2c .unit-content .title').css('top', '4%');
		$('.b2c .unit-content .diagonal-list-item.item-1').css('left', '0%');
		$('.b2c .unit-content .diagonal-list-item.item-2').css('left', '20%');
		$('.b2c .unit-content .diagonal-list-item.item-3').css('left', '40%');
		$('.b2c .unit-content .diagonal-list-item.item-4').css('left', '60%');
		$('.b2c .unit-background').css('transform','rotate(4deg)');
	}
	if($('.b2c').isInViewport()) {
		// B2B END
		$('.b2b .unit-background').css('transform', 'rotate(4deg)');
		$('.b2b .unit-content .title').css('top', '70%');
		$('.b2b .unit-content .diagonal-list-item.item-1').css('left', '60%');
		$('.b2b .unit-content .diagonal-list-item.item-2').css('left', '45%');
		$('.b2b .unit-content .diagonal-list-item.item-3').css('left', '30%');
		$('.b2b .unit-content .diagonal-list-item.item-4').css('left', '15%');
		$('.b2b .unit-content .diagonal-list-item.item-5').css('left', '0%');
	}
	if($('.b2c .diagonal-list .item-3').isInViewport()) {
		// B2C MIDDLE
		$('.b2c .unit-content .title').css('top', '40%');
		
		if(window.innerWidth < 768) {
			$('.b2c .unit-content .diagonal-list-item').css('left', '0%');
		}else{
			$('.b2c .unit-content .diagonal-list-item').css('left', '30%');
		}

		$('.b2c .unit-background').css('transform', 'rotate(0deg)');
	}
	if($('#career').isInViewport()) {
		// B2C END
		$('.b2c .unit-content .title').css('top', '70%');
		$('.b2c .unit-content .diagonal-list-item.item-1').css('left', '60%');
		$('.b2c .unit-content .diagonal-list-item.item-2').css('left', '40%');
		$('.b2c .unit-content .diagonal-list-item.item-3').css('left', '20%');
		$('.b2c .unit-content .diagonal-list-item.item-4').css('left', '0%');
		$('.b2c .unit-background').css('transform', 'rotate(-4deg)');
	}
});

// CV FILENAME
$('.cv-file').change(function() {
	let file = $(this)[0].files[0].name;
	$('.upload-file-label-title').text(file);
});

// MOBILE MENU
if(window.innerWidth < 1198) {
	$('#header button, #header a').click(function(){
		if($(this).hasClass('open-menu')) {
			$('#menu').fadeIn();
		}
		else {
			$('#menu').fadeOut();
		}
	})
}

// ANCHOR LINKS
$('#menu a').each(function(){
	let ancor = $(this).attr('href'),
	 	home_url = window.location.origin,
		url = home_url+'/'+ancor;
	if($('body').not('.home')) {
		$(this).attr('href', url);
	}
})

// Tiny Slider
var slider = tns({
    container: '.features',
	items: 1,
	mouseDrag: true,
	swipeAngle: false,
	speed: 400,
	nav: false,
	controls: true,
	controlsPosition: 'bottom',
	controlsText: [' ', ' '],
	edgePadding: 24,
	responsive: {
		768: {
		  items: 2,
		},
		1024: {
			items: 4
		 }
	  }
});

